import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import messages from '../../../../../text/messages';
import { formSettings } from './settings';
import WizardButtons from '../../../../../components/wizard/navigator/buttons';
import { logout } from '../../../../../reducers/identity';
import { FormattedMessage, FormattedDate } from 'react-intl';
import { getFullName } from '../../../../../utilities/string';
import { sign, getSignatures } from '../../../../../reducers/signatures';
import { getDocuments } from '../utilities';

class DoneStep extends React.Component {
    constructor(props) {
        super(props);

        this.submit = this.submit.bind(this);
        this.getSignatureId = this.getSignatureId.bind(this);
    }

    componentDidMount() {
        const { role, getSignatures } = this.props;
        getSignatures(role);
    }

    submit() {
        const { role, signature, sign, logout } = this.props;
        if (signature) {
            logout(() => (window.location = 'http://www.greenlight.ai'));
            return;
        }

        sign(role, this.getSignatureId(), () => logout(() => (window.location = 'http://www.greenlight.ai')));
    }

    getSignatureId() {
        const { i9 } = this.props;
        const { id, worker_user_id } = i9;
        return `i9-witnesses-by-${id}-for-${worker_user_id}`;
    }

    render() {
        const { handleSubmit, submitting, back, i9Docs, profile, i9, signatures } = this.props;
        if (!signatures) return null;

        const { worker_first_name, worker_last_name } = i9;
        const worker_name = worker_first_name + ' ' + worker_last_name;

        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="row section">
                    <div className="col-xs-12">
                        <FormattedMessage
                            id={'done.witness.intro1'}
                            defaultMessage={'Here’s a summary of what you witnessed.  Please confirm by clicking the “E-Sign” button below.'}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-xs-12 col-sm-9">
                        <div className="row group">
                            <div className="col-xs-12 all-done-label">
                                <FormattedMessage {...messages.yourName} />
                            </div>
                            <div className="col-xs-12 col-sm-6">{getFullName(profile)}</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 all-done-label">
                                <FormattedMessage id={'verifiedDocuments'} defaultMessage={'Verified Documents for {name}'} values={{ name: worker_name }} />
                            </div>
                            <div className="col-xs-12 col-sm-6">{i9Docs.map((doc, i) => <p key={i}>{doc.type}</p>)}</div>
                        </div>
                        <div className="row">
                            <div className="col-xs-12 all-done-label">
                                <FormattedMessage {...messages.witnessDate} />
                            </div>
                            <div className="col-xs-12 col-sm-6">
                                <FormattedDate month="long" day="numeric" year="numeric" value={new Date()} />
                            </div>
                        </div>
                    </div>
                </div>

                <WizardButtons
                    disabled={submitting}
                    back={{ action: back }}
                    submit={{ message: <FormattedMessage id={'esign'} defaultMessage={'E-SIGN'} /> }}
                />
            </form>
        );
    }
}

DoneStep = reduxForm(formSettings)(DoneStep);
const mapStateToProps = (state, props) => {
    const profile = state.identity.profile;
    const details = state.identity.details;
    const { id, worker_user_id } = details;
    const signatureId = `i9-witnesses-by-${id}-for-${worker_user_id}`;
    const signatures = state.signatures.list;
    const signature = signatures ? signatures.find(s => s.name === signatureId) : undefined;

    return {
        role: state.identity.role,
        profile,
        i9: details,
        signatures,
        signature,
        i9Docs: getDocuments(props)
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            getSignatures,
            sign,
            logout
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DoneStep);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/done.jsx